import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Tag } from '@enechain/ecloud-designsystem'

import { ApiKeyStatus } from '~/gen/proto/bff/v1/model_pb'

type Props = {
  status: ApiKeyStatus
}
export const ApiKeyStatusTag: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation()
  const label = (): string => {
    switch (status) {
      case ApiKeyStatus.ACTIVE:
        return t('pages.api_keys.value.active')
      case ApiKeyStatus.INACTIVE:
        return t('pages.api_keys.value.inactive')
      default:
        return ''
    }
  }
  return (
    <Tag
      color="Text.highEmphasis"
      backgroundColor={
        status === ApiKeyStatus.ACTIVE
          ? 'Surface.positiveMid'
          : 'Surface.neutralMid'
      }
    >
      {label()}
    </Tag>
  )
}
